/* eslint-disable*/
import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faSearch,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

// Import the lightbox component and styles
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

const Shareview = () => {
  const [loading, setLoading] = useState(false);
  const [shareLoading, setShareLoading] = useState(null); // Track individual share button loading
  const [error, setError] = useState(null);
  const [filtersReset, setFiltersReset] = useState(false);
  const token = localStorage.getItem("authToken");

  const [shareViewData, setShareViewData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 100;

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Lightbox state
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  // Format date for API: YYYY-MM-DD
  const formatAPIDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const fetchShareViewData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}researchCalls/dailyshareviewresult`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          params: {
            page,
            limit,
            ...(startDate &&
              endDate && {
                sdate: formatAPIDate(startDate),
                edate: formatAPIDate(endDate),
              }),
          },
        }
      );

      if (response.data && response.data.success) {
        setShareViewData(response.data.data.shareview || []);
        setTotal(response.data.data.total || 0);
        setPageCount(response.data.data.totalPages || 1);
      } else {
        setError("Failed to fetch data");
      }
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchShareViewData();
  }, [page]);

  useEffect(() => {
    if (filtersReset) {
      fetchShareViewData();
    }
    setFiltersReset(false);
  }, [filtersReset]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pageCount) setPage(newPage);
  };

  // Function to open lightbox for a specific image
  const openLightbox = (imgUrl, index) => {
    if (!imgUrl) {
      showToast.error("No image available to view");
      return;
    }
    setLightboxIndex(index);
    setLightboxOpen(true);
  };

  const handleTelegramShare = async (id) => {
    try {
      setShareLoading(id);
      const response = await axios.post(
        `${API_URL}notification/${id}/share`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data || response.data.success || response.status === 201) {
        showToast.success("Shared to Telegram successfully!");
      } else {
        showToast.error("Failed to share on Telegram");
      }
    } catch (error) {
      showToast.error("Failed to share on Telegram");
      console.error("Telegram share error:", error);
    } finally {
      setShareLoading(null);
    }
  };

  const handleChangeDate = (dates) => {
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
      return;
    }
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleClearDate = () => {
    setStartDate(null);
    setEndDate(null);
    setFiltersReset(true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchShareViewData();
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  // Prepare slides for lightbox - only include posts that have images
  const slides = shareViewData
    .filter((post) => post.imgurl)
    .map((post) => ({ src: post.imgurl }));

  return (
    <div className="page-header-fixed page-sidebar-fixed mt-5">
      {/* Search / Date Filter */}
      <div className="panel panel-default with-rounded-corner with-shadow mb-3">
        <form onSubmit={handleSubmit}>
          <div className="panel-heading border-0">
            <span className="panel-title">Search</span>
          </div>
          <div className="panel-body d-flex align-items-center gap-2">
            <DatePicker
              selected={startDate}
              onChange={handleChangeDate}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              isClearable
              toggleCalendarOnIconClick
              placeholderText="Select a date range"
              className="form-control"
              monthsShown={3}
              openToDate={startDate} // Open at selected date if exists
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              scrollableYearDropdown
              yearDropdownItemNumber={15}
              minDate={new Date(2018, 0, 1)}
              maxDate={new Date(2030, 11, 31)}
              dateFormat="dd-MM-yyyy"
            />
            <button type="submit" className="btn btn-primary">
              Submit
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleClearDate}
            >
              Clear
            </button>
          </div>
        </form>
      </div>

      {/* Table and Pagination */}
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div className="d-flex align-items-center justify-content-between p-2">
          <h4 className="panel-title">Manage Sharing Research Calls</h4>
          <div>
            <span style={{ fontSize: "0.8rem" }} className="me-2">
              {start} to {end} of {total}
            </span>
            <button
              className="btn btn-default btn-sm"
              title="Previous"
              onClick={() => handlePageChange(page - 1)}
              disabled={page === 1}
            >
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            &nbsp;
            <button
              className="btn btn-default btn-sm"
              title="Next"
              onClick={() => handlePageChange(page + 1)}
              disabled={page === pageCount}
            >
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>

        {loading && <LoadingSpinner />}

        {error && <div className="alert alert-danger">{error}</div>}

        {!loading && !error && shareViewData.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-condensed table-bordered bg-white">
              <thead>
                <tr>
                  <th className="text-center">Sr. No.</th>
                  <th>Image</th>
                  <th>Date</th>
                  <th>Share</th>
                </tr>
              </thead>
              <tbody>
                {shareViewData.map((post, index) => {
                  const d = new Date(post.created_on);
                  const day = String(d.getDate()).padStart(2, "0");
                  const month = String(d.getMonth() + 1).padStart(2, "0");
                  const year = d.getFullYear();
                  let hours = d.getHours();
                  const minutes = String(d.getMinutes()).padStart(2, "0");
                  const ampm = hours >= 12 ? "pm" : "am";
                  hours = hours % 12 || 12; // convert 0 -> 12 for 12-hour format
                  const credate = `${day}-${month}-${year}, ${hours}:${minutes}${ampm}`;

                  // Calculate the actual index in the filtered slides array
                  const actualIndex = shareViewData
                    .slice(0, index)
                    .filter((item) => item.imgurl).length;

                  return (
                    <tr key={post.id}>
                      <td className="text-center">
                        {(page - 1) * limit + index + 1}
                      </td>
                      <td>
                        {post.imgurl ? (
                          <img
                            src={post.imgurl}
                            alt=""
                            style={{ width: "200px", cursor: "pointer" }}
                            onClick={() =>
                              openLightbox(post.imgurl, actualIndex)
                            }
                          />
                        ) : (
                          <span className="text-muted">No image available</span>
                        )}
                      </td>
                      <td>{credate}</td>
                      <td>
                        {/* View Button - opens lightbox */}
                        <button
                          className="btn btn-warning"
                          title="View Image"
                          disabled={!post.imgurl}
                          onClick={() => openLightbox(post.imgurl, actualIndex)}
                        >
                          <FontAwesomeIcon icon={faSearch} />
                        </button>

                        <button
                          className="btn btn-primary mx-1"
                          onClick={() => handleTelegramShare(post.id)}
                          disabled={shareLoading === post.id}
                          title="Share to Telegram"
                        >
                          {shareLoading === post.id ? (
                            <div
                              className="spinner-border spinner-border-sm"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <FontAwesomeIcon icon={faShare} />
                          )}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          !loading &&
          !error && (
            <div className="p-3">
              No records found.{" "}
              <a href="/research/performance/edit/">Add a record</a>.
            </div>
          )
        )}
      </div>

      {/* Lightbox component */}
      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={slides}
        index={lightboxIndex}
        on={{
          view: ({ index: currentIndex }) => setLightboxIndex(currentIndex),
        }}
      />

      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default Shareview;
